export const SET_NOTIFICATION_COUNTER_AMOUNT = 'SET_NOTIFICATION_COUNTER_AMOUNT';